import { Box } from '@mui/material'
import { PropsWithChildren } from 'react'
import { useStyles } from './styles'
import UserInfo from './user-info'
import UserLogoDetails from './user-logo-details'

const Header = ({ children }: PropsWithChildren) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Box className={classes.headerContainer}>
          <Box className={classes.userContainer}>
            <UserLogoDetails />
            <UserInfo />
          </Box>
          <Box className={classes.divisor} />
          {children}
        </Box>
      </Box>
      <Box className={classes.divisor} />
    </Box>
  )
}

export default Header
